import React, { createContext, useState } from 'react';

export const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <DrawerContext.Provider value={{ open, showDrawer, onClose }}>
            {children}
        </DrawerContext.Provider>
    );
};